import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-media-slider-fullscreen .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 10,
			slidesPerView: 'auto',
			centeredSlides: true,
			modules: [Navigation],
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
		};

		new Swiper(slider, settings);
	});
}
